import { z } from "zod";

import { PYUseQueryOptions } from "../../../api/hooks/StandardQueryArguments";

import { getCurrentUser, meResponseSchema } from "../../../api/services";

export const currentUserQuery = (options?: PYUseQueryOptions<z.infer<typeof meResponseSchema>>) => {
	return {
		queryKey: ["auth-current-user"],
		queryFn: () => getCurrentUser(),
		meta: {
			errorMessage: "There was an error getting the current user.",
		},
		...options,
	};
};
